export default "__VITE_ASSET__a9ca20d7__"